/**
 * Словник: sv.
 * Згенеровано tool/gen_web_locales.py з lib/l10n/app_sv.arb — руками не правити.
 *
 * ⚠️ Новий рядок: спершу в ARB усіх мов, потім ключ у en.ts і перегенерація.
 * Паритет ключів перевіряється на збірці (npm run check:i18n).
 */
export default {
  waiting: "⏳ Väntar på den andra deltagaren...",
  connectionLost: "Anslutningen bröts",
  peerLeft: "👋 Den andra deltagaren lämnade samtalet",
  connectionError: "🚫 Anslutningsfel",
  connectionFailedTryAgain: "🚫 Det gick inte att ansluta till servern. Försök igen.",
  reconnectionFailed: "🚫 Anslutningen bröts. Det gick inte att återansluta efter {attempts} försök.",
  connectionErrorWithDetails: "🚫 Anslutningsfel: {error}",
  speakerLoud: "Högt",
  speakerEar: "Lur",
  copyRoomId: "Kopiera rums-ID",
  share: "Dela",
  linkCopied: "🔗 Länk kopierad!",
  idCopied: "🆔 ID kopierat!",
  startMeeting: "Starta möte",
  chooseAction: "Välj en åtgärd",
  createNewRoom: "Nytt rum",
  scheduleCall: "Schemalägg samtal",
  calendarOpened: "📅 Kalendern har öppnats",
  linkCopiedToClipboard: "🔗 Länken har kopierats till urklipp",
  enterRoomId: "Ange rums-ID",
  roomIdValidationError: "Rums-ID får bara innehålla bokstäver, siffror och bindestreck",
  joinRoom: "GÅ MED",
  termsAndPrivacyHelp: "Villkor och integritet | Hjälp",
  invite: "Bjud in",
  mySettings: "Mina inställningar",
  peerSettings: "Den andras inställningar",
  blockRemoteControl: "Blockera fjärrstyrning",
  iAgreeToTerms: "Jag godkänner tjänstens villkor",
  termsOfUse: "Användarvillkor",
  privacyPolicy: "Integritetspolicy",
  howToUse: "Så fungerar det",
  termsAcceptanceRequired: "Du måste godkänna villkoren för att använda tjänsten",
  ok: "OK",
  permissionsRequired: "Behörigheter krävs",
  permissionsNeededMessage: "Appen behöver följande behörigheter för att fungera korrekt:",
  permissionsNote: "Obs! När du ändrar behörigheter i Inställningar startar iOS om appen. Det är helt normalt.",
  permissionsEnableMessage: "Aktivera de här behörigheterna i enhetens inställningar för att fortsätta.",
  cancel: "Avbryt",
  openSettings: "Öppna inställningar",
  websocketError: "WebSocket-fel",
  roomFull: "Rummet är fullt",
  timeExpired: "Tiden är slut",
  remaining: "kvar",
  mediaPermissionsRequired: "Videosamtal kräver åtkomst till kamera och mikrofon. Ge behörighet i webbläsaren.",
  mediaPermissionsRequiredMobile: "Videosamtal kräver åtkomst till kamera och mikrofon. Ge behörighet i appens inställningar.",
  browserSettings: "Webbläsarinställningar",
  openAppSettings: "Öppna inställningar",
  grantPermissions: "Ge behörighet",
  permissionsNotGranted: "Behörighet saknas. Ge behörighet för att fortsätta.",
  permissionRequestError: "Fel vid begäran om behörighet: {error}",
  camera: "Kamera",
  microphone: "Mikrofon",
  cameraDescription: "För att överföra video",
  microphoneDescription: "För att överföra ljud",
  continueWithoutPermissions: "Fortsätt utan behörighet",
  mediaPermissionsRequiredFallback: "Videosamtal kräver mediebehörighet. Ge behörighet i webbläsarens inställningar.",
  mediaPermissionsRequiredMobileFallback: "Videosamtal kräver mediebehörighet. Ge behörighet i appens inställningar.",
  browserSettingsFallback: "Webbläsarinställningar",
  openAppSettingsFallback: "Öppna inställningar",
  permissionsPermanentlyDenied: "Behörigheten har nekats permanent. Aktivera den i appens inställningar.",
  continueText: "Fortsätt",
  mirror: "Spegla",
  fitContain: "Anpassa",
  fitCover: "Fyll",
  switchCamera: "Vänd",
  block: "Blockera",
  pip: "PiP",
  mic: "Mikrofon",
  video: "Video",
  speaker: "Högtalare",
  readyToConnect: "Redo att prata?",
  startOneOnOne: "Starta ett videosamtal",
  createPrivateLink: "Länken klar på en sekund",
  welcomeExplainer: "Skapa en länk och skicka den till vem som helst. Den öppnas även utan appen.",
  joinHaveLink: "Har du en länk?",
  joinFieldHint: "Klistra in länk eller ID",
  roomInputInvalid: "Klistra in en samtalslänk eller ett rums-ID (bokstäver, siffror och bindestreck)",
  guestTitle: "Du är inbjuden till ett videosamtal",
  guestBody: "Rummet är klart. Den andra personen ser dig så fort du går med.",
  guestJoin: "Gå med",
  guestFreeNote: "Det är alltid gratis att gå med",
  guestCreateOwn: "Skapa mitt eget rum",
  guestInvalidTitle: "Länken verkar vara trasig",
  guestInvalidBody: "Be om länken igen eller skapa ditt eget rum.",
  inviteCardTitle: "Ditt rum är klart",
  inviteCardBody: "Skicka länken till den du vill prata med",
  inviteShareLink: "Dela länk",
  inviteCopy: "Kopiera",
  inviteBrowserHint: "Öppnas i alla webbläsare. Du behöver inte installera appen.",
  inviteSentHint: "Skickat? Den andra personen dyker upp här så fort länken öppnas.",
  inviteShareMessage: "Häng med i mitt videosamtal på One2One 👋\nÖppna bara länken. Det funkar i webbläsaren, inget att installera:\n{link}",
  copyLink: "Kopiera länk",
  consentBannerText: "Får vi samla in användningsstatistik? Den visar vilka funktioner som används. Samtalsinnehåll ingår aldrig.",
  consentAllow: "Tillåt",
  consentDeny: "Tillåt inte",
  privacySettingsLink: "Statistikinställningar",
} as const;
